module.exports = __webpack_public_path__ + "static/pp-c530f27ed2fa6d7c39b2876a0ee6e02a.png";